export var BundleAnalyzerState;
(function (BundleAnalyzerState) {
    BundleAnalyzerState[BundleAnalyzerState["Ok"] = 0] = "Ok";
    BundleAnalyzerState[BundleAnalyzerState["OutOfStock"] = 1] = "OutOfStock";
    BundleAnalyzerState[BundleAnalyzerState["NoAccessories"] = 2] = "NoAccessories";
    BundleAnalyzerState[BundleAnalyzerState["DoesNotFit"] = 3] = "DoesNotFit";
})(BundleAnalyzerState || (BundleAnalyzerState = {}));
